import { Download } from "@mui/icons-material";
import { Box, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Toolbar, Typography } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import BusAdministrationApiService from "../../adapters/xhr/BusAdministrationApiService";
import BusClaimApiService from "../../adapters/xhr/BusClaimApiService";
import { MyButton } from "../../components/my-button/MyButton";
import { MyCheckbox } from "../../components/my-checkbox/MyCheckbox";
import { MyDatePicker } from "../../components/my-date-picker/MyDatePicker";
import { MyDropdown } from "../../components/my-dropdown/MyDropdown";
import { MySelect } from "../../components/my-select/MySelect";
import { BusProviderOptions, DisplayClaimType, lngs, ReceiptType, Reports } from "../../Constant";
import MyContext from "../../contexts/MyContext";
import SnackbarUtils from "../../SnackbarUtils";
import { formatDate, formatTime } from "../../Utils";

export const BusReportsPage = () => {
  const hiddenCSVSettlementLink = React.useRef(null);
  const hiddenCSVSUSLink = React.useRef(null);
  const [catchLateApprovals, setCatchLateApprovals] = useState(false);
  const [totalReimbursementSEK, setTotalReimbursementSEK] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [susBackupRows, setSusBackupRows] = useState([]);
  const [settlementRows, setSettlementRows] = useState([]);
  const [providers, setProviders] = useState([]);
  const [startDate, setStartDate] = useState();
  const [startDateErr, setStartDateErr] = useState(false);
  const [endDate, setEndDate] = useState();
  const [endDateErr, setEndDateErr] = useState();
  const [payouts, setPayouts] = useState([]);
  const [payoutNumber, setPayoutNumber] = useState("");
  const { t, i18n } = useTranslation();
  const myContext = useContext(MyContext);
  const options = [
    { key: Reports.Fraud, value: t("fraud") },
    { key: Reports.SUS, value: t("sus") },
    { key: Reports.SusHistory, value: t("sus_history") },
    { key: Reports.SWISH, value: t("swish") },
    { key: Reports.Settlement, value: t("settlement") },
  ];
  const [fileExport, setFileExport] = useState({ key: Reports.SUS, value: t("sus") });
  const [sortBy, setSortBy] = useState("ReimbursementSEK");
  const [ascending, setAscending] = useState(false);
  const [showMore, setShowMore] = useState([]);
  const [stationsLoaded, setStationsLoaded] = useState(false);
  const [swishStatus, setSwishStatus] = useState(null);

  const claimColumns = [
    { id: "CaseNumber", key: "CaseNumber", label: t("case_number"), minWidth: 170, sortable: true },
    { id: "ClaimStatus", key: "ClaimStatus", label: t("status"), minWidth: 170, sortable: true },
    { id: "Created", key: "Created", label: t("registred_datetime"), minWidth: 170, sortable: true },
    { id: "TransportationNumber", key: "TransportationNumber", label: t("transportation_number"), minWidth: 170, sortable: true },
    { id: "ReimbursementSEK", key: "ReimbursementSEK", label: t("reimbursement_SEK"), minWidth: 170, sortable: true },
    { id: "TicketPriceSEK", key: "TicketPriceSEK", label: t("ticket_price_SEK"), minWidth: 170 },
    { id: "DelayMinutes", key: "DelayMinutes", label: t("delay_min"), minWidth: 170 },
    { id: "DepartureStation", key: "DepartureStation", label: t("departure_station"), minWidth: 180, sortable: false },
    { id: "ArrivalStation", key: "ArrivalStation", label: t("arrival_station"), minWidth: 180, sortable: false },
    { id: "Comment", key: "Comment", label: t("comment"), minWidth: 170, sortable: true },
    { id: "TicketValidFrom", key: "TicketValidFrom", label: t("ticket_valid_from"), minWidth: 180 },
    { id: "TicketValidTo", key: "TicketValidTo", label: t("ticket_valid_to"), minWidth: 180 },
    { id: "TicketNumber", key: "TicketNumber", label: t("ticket_number"), minWidth: 170, sortable: true },
    { id: "SentToTopDesk", key: "SentToTopDesk", label: t("sent_to_TopDesk"), minWidth: 170, sortable: true },
  ];
  const settlementColumns = [
    { id: "CaseNumber", key: "CaseNumber", label: t("case_number"), minWidth: 170, sortable: true },
    { id: "Created", key: "Created", label: t("registred_datetime"), minWidth: 170, sortable: true },
    { id: "TransportationNumber", key: "TransportationNumber", label: t("transportation_number"), minWidth: 170, sortable: true },
    { id: "DepartureDate", key: "DepartureDate", label: t("departure_date"), minWidth: 180, sortable: false },
    { id: "DepartureStation", key: "DepartureStation", label: t("departure_station"), minWidth: 180, sortable: false },
    { id: "ArrivalStation", key: "ArrivalStation", label: t("arrival_station"), minWidth: 180, sortable: false },
    { id: "Comment", key: "Comment", label: t("comment"), minWidth: 170, sortable: true },
    { id: "TicketNumber", key: "TicketNumber", label: t("ticket_number"), minWidth: 170, sortable: true },
    { id: "ExternalTicketType", key: "ExternalTicketType", label: t("ticket_type"), minWidth: 200, sortable: false },
    { id: "ReimbursementSEK", key: "ReimbursementSEK", label: t("total_reimbursement_SEK"), minWidth: 170, sortable: true },
    { id: "TicketReimbursementSEK", key: "TicketReimbursementSEK", label: t("ticket_reimbursement_SEK"), minWidth: 170, sortable: false },
    { id: "TransportationCost", key: "TransportationCost", label: t("transportation_cost_SEK"), minWidth: 170, sortable: false },
    { id: "TicketPriceSEKIncludeVAT", key: "TicketPriceSEKIncludeVAT", label: t("ticket_price_SEK_include_vat"), minWidth: 170 },
    { id: "TicketPriceSEKExcludeVAT", key: "TicketPriceSEKExcludeVAT", label: t("ticket_price_SEK_exclude_vat"), minWidth: 170 },
    { id: "Provider", key: "Provider", label: t("provider"), minWidth: 170 },
    { id: "SentSusFileDate", key: "SentSusFileDate", label: t("sent_sus_file_date"), minWidth: 180, sortable: true },
    { id: "SentSwishPayoutDate", key: "SentSwishPayoutDate", label: t("sent_swish_payout_date"), minWidth: 180, sortable: true },
  ];
  const settlementCSVReportColumns = [
    { id: "Id", key: "Id", label: "Id", minWidth: 170, sortable: true },
    { id: "CaseNumber", key: "CaseNumber", label: t("case_number"), minWidth: 170, sortable: true },
    { id: "Created", key: "Created", label: t("registred_datetime"), minWidth: 170, sortable: true },
    { id: "TransportationNumber", key: "TransportationNumber", label: t("transportation_number"), minWidth: 170, sortable: true },
    { id: "DepartureDate", key: "DepartureDate", label: t("departure_date"), minWidth: 180, sortable: false },
    { id: "DepartureStation", key: "DepartureStation", label: t("departure_station"), minWidth: 180, sortable: false },
    { id: "ArrivalStation", key: "ArrivalStation", label: t("arrival_station"), minWidth: 180, sortable: false },
    { id: "Comment", key: "Comment", label: t("comment"), minWidth: 170, sortable: true },
    { id: "TicketNumber", key: "TicketNumber", label: t("ticket_number"), minWidth: 170, sortable: true },
    { id: "ExternalTicketType", key: "ExternalTicketType", label: t("ticket_type"), minWidth: 200, sortable: false },
    { id: "ReimbursementSEK", key: "ReimbursementSEK", label: t("total_reimbursement_SEK"), minWidth: 170, sortable: true },
    { id: "TicketReimbursementSEK", key: "TicketReimbursementSEK", label: t("ticket_reimbursement_SEK"), minWidth: 170, sortable: false },
    { id: "TransportationCost", key: "TransportationCost", label: t("transportation_cost_SEK"), minWidth: 170, sortable: false },
    { id: "TicketPriceSEKIncludeVAT", key: "TicketPriceSEKIncludeVAT", label: t("ticket_price_SEK_include_vat"), minWidth: 170 },
    { id: "TicketPriceSEKExcludeVAT", key: "TicketPriceSEKExcludeVAT", label: t("ticket_price_SEK_exclude_vat"), minWidth: 170 },
    { id: "Provider", key: "Provider", label: t("provider"), minWidth: 170 },
    { id: "SentSusFileDate", key: "SentSusFileDate", label: t("sent_sus_file_date"), minWidth: 180, sortable: true },
    { id: "SentSwishPayoutDate", key: "SentSwishPayoutDate", label: t("sent_swish_payout_date"), minWidth: 180, sortable: true },
  ];
  const fraudReportColumns = [
    { id: "ReimbursementSEK", label: t("reimbursement_SEK"), minWidth: 170, sortable: true },
    { id: "TicketPriceSEK", label: t("ticket_price_SEK"), minWidth: 170, sortable: true },
    { id: "TotalClaims", label: t("number_of_claims"), minWidth: 170, sortable: true },
    { id: "ClaimWithoutTicketNumber", label: t("number_of_claims_without_ticket"), minWidth: 170, sortable: true },
    { id: "CaseNumber", label: t("case_number"), minWidth: 170, sortable: true },
  ];
  const renderSusHistoryActions = (row) => {
    return <Download className="selector margin top-0 bottom-0 right-1" onClick={async () => setSusBackupRows(await fetchSusHistoryClaims(row["date"]))} />;
  };
  const susHistoryColumns = [
    { id: "date", label: t("date"), minWidth: 170, sortable: false },
    { id: "reimbursementSEK", label: t("reimbursement_SEK"), minWidth: 170, sortable: false },
    { id: "actions", label: t("actions"), minWidth: 170, sortable: false, render: renderSusHistoryActions },
  ];

  const [columns, setColumns] = useState(claimColumns);

  const EnhancedTableToolbar = () => {
    let title = "";
    switch (fileExport.key) {
      case Reports.SUS:
        title = `${t("sus_report")} (# ${totalPages}, ${totalReimbursementSEK} ${t("kr")})`;
        break;
      case Reports.SusHistory:
        title = t("sus_history");
        break;
      case Reports.SWISH:
        title = `${t("swish_report")} (# ${totalPages}, ${totalReimbursementSEK} ${t("kr")})`;
        break;
      case Reports.Settlement:
        title = t("settlement_report");
        break;
      case Reports.Fraud:
        title = t("fraud_report");
        break;
      default:
        break;
    }
    return (
      <Toolbar>
        <Typography sx={{ flex: "1 1 100%" }} variant="h6" id="tableTitle" component="div">
          {title}
        </Typography>
      </Toolbar>
    );
  };

  const fetchBusStations = useCallback(async () => {
    let response = await BusAdministrationApiService.getBusStations();
    if (response.isSuccess) {
      myContext.changeStops(response.data);
    }
  }, []);

  const fetchTrainStations = useCallback(async () => {
    let response = await BusAdministrationApiService.getTrainStations();
    if (response.isSuccess) {
      myContext.changeTrainStations(response.data);
    }
  }, []);

  // Fetch stations first and set loading state
  useEffect(() => {
    const loadStations = async () => {
      try {
        const promises = [];

        if (!myContext.trainStations || myContext.trainStations.length === 0) {
          promises.push(fetchTrainStations());
        }

        if (!myContext.stops || myContext.stops.length === 0) {
          promises.push(fetchBusStations());
        }

        if (promises.length > 0) {
          await Promise.all(promises);
        }

        setStationsLoaded(true);
      } catch (error) {
        console.error("Failed to load stations:", error);
        SnackbarUtils.error(t("error"));
      }
    };

    loadStations();
  }, [fetchTrainStations, fetchBusStations]);

  // Only fetch claims after stations are loaded
  useEffect(() => {
    if (!stationsLoaded) return; // Don't fetch claims until stations are loaded

    const fetchData = async () => {
      try {
        let data;
        switch (fileExport.key) {
          case Reports.SUS:
            await getTotalReimbursementSEK();
            data = await fetchClaimReport(page, rowsPerPage, DisplayClaimType.SusReport);
            break;
          case Reports.SusHistory:
            data = await fetchSusHistoryDates();
            break;
          case Reports.Settlement:
            data = await fetchClaimReport(page, rowsPerPage, DisplayClaimType.Settlement);
            break;
          case Reports.Fraud:
            data = await fetchFraudReport();
            break;
          case Reports.SWISH:
            await getTotalReimbursementSEK();
            data = await fetchClaimReport(page, rowsPerPage, DisplayClaimType.SwishReport);
            fetchSwishStatus();
          default:
            break;
        }

        if (data) {
          setRows(data.items);
          setTotalPages(data.totalCount);
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        SnackbarUtils.error(t("error"));
      }
    };

    fetchData();
  }, [stationsLoaded, fileExport, startDate, endDate, sortBy, ascending, rowsPerPage, page, catchLateApprovals, providers]);

  useEffect(() => {
    const fetchData = async () => {
      if (settlementRows && settlementRows.length > 0) {
        hiddenCSVSettlementLink.current.link.click();
        var data = await fetchClaimReport(0, 10, DisplayClaimType.Settlement);
        setPage(0);
        setRowsPerPage(10);
        setRows(data.items);
        setTotalPages(data.totalCount);
      }
    };
    fetchData();
  }, [settlementRows]);

  useEffect(() => {
    if (susBackupRows && susBackupRows.length > 0) {
      hiddenCSVSUSLink.current.link.click();
    }
  }, [susBackupRows]);

  useEffect(() => {
    if (payoutNumber) {
      const fetchData = async () => {
        let completed = false;
        const payouts = await BusClaimApiService.getSwishPayouts({ payoutNumber });
        if (payouts && payouts.data && payouts.data.length > 0) completed = payouts.data.every((p) => p.status.toLowerCase() !== "created");
        else completed = true;
        if (!completed) setTimeout(fetchData, 5000);
        else {
          setPayouts(payouts.data);
          // await getTotalReimbursementSEK();
          // var data = await fetchClaimReport(0, 10, DisplayClaimType.SwishReport);
          // setPage(0);
          // setRowsPerPage(10);
          // setRows(data.items);
          // setTotalPages(data.totalCount);
        }
      };
      fetchData();
    }
  }, [payoutNumber]);

    const fetchSwishStatus = () => {

    const initSwishStatusPage = () => {
        const sp = new window.StatusPage.page({
          page: "05xjpj3wm8rs",
        });


        sp.status({
          success: (data) => {
            setSwishStatus(data.status.indicator);
            console.log(data.status.indicator)

          },
        });
      };

      if (window.StatusPage) {
        initSwishStatusPage();
      } else {
        const script = document.createElement("script");
        script.src = "https://cdn.statuspage.io/se-v2.js";
        script.async = true;
        script.onload = initSwishStatusPage;
        document.body.appendChild(script);
      }
      };

  const fetchFraudReport = async () => {
    let payload = {
      ascending: ascending,
      sortBy: sortBy,
      pageNumber: page + 1,
      pageSize: rowsPerPage,
    };
    if (startDate) {
      payload.startDate = formatDate(startDate);
    }
    if (endDate) {
      payload.endDate = formatDate(endDate);
    }
    let response = await BusClaimApiService.getFraudReport(payload);
    if (response?.isSuccess && response.data.items.length >= 0) {
      response.data.items = response.data.items.map((option) => {
        let rObj = {};
        rObj["IdentityNumber"] = option.identityNumber;
        rObj["CaseNumber"] = option.caseNumber;
        rObj["FirstName"] = option.firstName;
        rObj["SurName"] = option.surName;
        rObj["ReimbursementSEK"] = option.reimbursementSEK;
        rObj["TicketPriceSEK"] = option.ticketPriceSEK;
        rObj["ClaimWithoutTicketNumber"] = option.claimWithoutTicketNumber;
        rObj["TotalClaims"] = option.totalClaims;
        rObj["FromDate"] = option.fromDate;
        rObj["ToDate"] = option.toDate;
        return rObj;
      });
      return response.data;
    }
  };

  const fetchSusHistoryDates = async () => {
    let payload = {
      ascending: ascending,
      sortBy: sortBy,
      pageNumber: page + 1,
      pageSize: rowsPerPage,
    };
    let response = await BusClaimApiService.getSusHistoryDates(payload);
    if (response?.isSuccess && response.data.items.length >= 0) {
      response.data.items = response.data.items.map((item) => {
        let rObj = {};
        rObj["date"] = formatDate(item.date);
        rObj["reimbursementSEK"] = item.totalReimbursementSEK;
        return rObj;
      });
      return response.data;
    }
  };

  const fetchSusHistoryClaims = async (date) => {
    let response = await BusClaimApiService.getSusHistoryClaims({ susDate: date });
    response.data = response.data.map((option) => {
      let rObj = {};
      rObj["Id"] = option.id;
      rObj["ExternalTicketType"] = option.externalTicketType;
      rObj["CaseNumber"] = option.caseNumber;
      rObj["Provider"] = option.provider;
      rObj["FromDate"] = option.fromDate;
      rObj["ToDate"] = option.toDate;
      rObj["ClaimStatus"] = i18n.language === lngs.en.code ? option.claimStatus?.name : option.claimStatus?.swedishName;
      rObj["Created"] = `${formatDate(option.created)} ${formatTime(option.created, true)}`;
      rObj["TransportationNumber"] = option.transportationNumber;
      rObj["ReimbursementSEK"] = option.reimbursementSEK;
      rObj["TicketReimbursementSEK"] = option.ticketReimbursementSEK > 0 ? option.ticketReimbursementSEK : "";
      let transportationCost = option.claimReceipts?.find((item) => item.receiptType.name == ReceiptType.Transportation)?.totalCost;
      rObj["TransportationCost"] = transportationCost && transportationCost > 0 ? transportationCost : "";
      rObj["TicketPriceSEK"] = option.ticketPriceSEK;
      rObj["TicketPriceSEKIncludeVAT"] = option.ticketPriceSEK;
      rObj["DelayMinutes"] = option.delayMinutes;
      rObj["DepartureStation"] = myContext.trainStations.find((item) => item.id === option.departureStationId)?.name ?? myContext.stops.find((item) => item.id === option.departureStationId)?.longName;
      rObj["ArrivalStation"] = myContext.trainStations.find((item) => item.id === option.arrivalStationId)?.name ?? myContext.stops.find((item) => item.id === option.arrivalStationId)?.longName;
      rObj["Comment"] = option.comment;
      rObj["DepartureDate"] = `${formatDate(option.departureDate)} ${formatTime(option.departureDate, true)}`;
      rObj["SentSusFileDate"] = `${formatDate(option.sentSusFileDate)} ${formatTime(option.sentSusFileDate, true)}`;
      rObj["TicketValidFrom"] = `${formatDate(option.ticketValidFrom)} ${formatTime(option.ticketValidFrom, true)}`;
      rObj["TicketValidTo"] = `${formatDate(option.ticketValidTo)} ${formatTime(option.ticketValidTo, true)}`;
      rObj["TicketNumber"] = option.ticketNumber;
      rObj["SentToTopDesk"] = `${formatDate(option.sentToTopDesk)} ${formatTime(option.sentToTopDesk, true)}`;
      return rObj;
    });
    return response.data;
  };

  const fetchClaimReport = async (pageNumber, pageSize, displayClaimType) => {
    let payload = {
      ascending: ascending,
      catchLateApprovals: catchLateApprovals,
      sortBy: sortBy,
      claimStatus: [],
      pageNumber: pageNumber + 1,
      pageSize: pageSize,
      providers: providers.map((item) => item.value),
      displayType: displayClaimType,
    };
    if (startDate) {
      payload.startDate = formatDate(startDate);
    }
    if (endDate) {
      payload.endDate = formatDate(endDate);
    }
    let response = await BusClaimApiService.getAll(payload);
    if (response?.isSuccess && response.data.items.length >= 0) {
      response.data.items = response.data.items.map((option) => {
        let rObj = {};
        rObj["Id"] = option.id;
        rObj["ExternalTicketType"] = option.externalTicketType;
        rObj["CaseNumber"] = option.caseNumber;
        rObj["Provider"] = option.provider;
        rObj["FromDate"] = option.fromDate;
        rObj["ToDate"] = option.toDate;
        rObj["ClaimStatus"] = i18n.language === lngs.en.code ? option.claimStatus?.name : option.claimStatus?.swedishName;
        rObj["Created"] = `${formatDate(option.created)} ${formatTime(option.created, true)}`;
        rObj["TransportationNumber"] = option.transportationNumber;
        rObj["ReimbursementSEK"] = option.reimbursementSEK;
        rObj["TicketReimbursementSEK"] = option.ticketReimbursementSEK > 0 ? option.ticketReimbursementSEK : "";
        let transportationCost = option.claimReceipts?.find((item) => item.receiptType.name == ReceiptType.Transportation)?.totalCost;
        rObj["TransportationCost"] = transportationCost && transportationCost > 0 ? transportationCost : "";
        rObj["TicketPriceSEK"] = option.ticketPriceSEK;
        rObj["TicketPriceSEKIncludeVAT"] = option.ticketPriceSEK;
        rObj["DelayMinutes"] = option.delayMinutes;
        rObj["DepartureStation"] = myContext.trainStations.find((item) => item.id === option.departureStationId)?.name ?? myContext.stops.find((item) => item.id === option.departureStationId)?.longName;
        rObj["ArrivalStation"] = myContext.trainStations.find((item) => item.id === option.arrivalStationId)?.name ?? myContext.stops.find((item) => item.id === option.arrivalStationId)?.longName;
        rObj["Comment"] = option.comment;
        rObj["DepartureDate"] = `${formatDate(option.departureDate)} ${formatTime(option.departureDate, true)}`;
        rObj["SentSusFileDate"] = `${formatDate(option.sentSusFileDate)} ${formatTime(option.sentSusFileDate, true)}`;
        rObj["SentSwishPayoutDate"] = `${formatDate(option.sentSwishPayoutDate)} ${formatTime(option.sentSwishPayoutDate, true)}`;
        rObj["TicketValidFrom"] = `${formatDate(option.ticketValidFrom)} ${formatTime(option.ticketValidFrom, true)}`;
        rObj["TicketValidTo"] = `${formatDate(option.ticketValidTo)} ${formatTime(option.ticketValidTo, true)}`;
        rObj["TicketNumber"] = option.ticketNumber;
        rObj["SentToTopDesk"] = `${formatDate(option.sentToTopDesk)} ${formatTime(option.sentToTopDesk, true)}`;
        return rObj;
      });
      return response.data;
    }
  };

  const getTotalReimbursementSEK = async () => {
    let payload = {
      claimStatus: [],
    };
    switch (fileExport.key) {
      case Reports.SUS:
        payload.displayType = DisplayClaimType.SusReport;
        break;
      case Reports.SWISH:
        payload.displayType = DisplayClaimType.SwishReport;
        break;
      case Reports.Settlement:
        payload.displayType = DisplayClaimType.Overview;
        break;
    }
    if (startDate) {
      payload.startDate = formatDate(startDate);
    }
    if (endDate) {
      payload.endDate = formatDate(endDate);
    }
    let response = await BusClaimApiService.getTotalReimbursementSEK(payload);
    if (response?.isSuccess) {
      setTotalReimbursementSEK(response.data);
    }
  };

  const handleSort = async (field, ascending) => {
    if (field === "DepartureStation") field = "DepartureStationId";
    if (field === "ArrivalStation") field = "ArrivalStationId";
    if (field === "Status") field = i18n.language === lngs.en.code ? "ClaimStatus" : "ClaimStatusSwedish";
    setSortBy(field);
    setAscending(ascending);
  };

  const handleFileExportChange = (fileExport) => {
    setFileExport(fileExport);
    setAscending(false);
    setSortBy("ReimbursementSEK");
    setPage(0);
    setRowsPerPage(10);
    if (fileExport.key !== Reports.SWISH) {
        setSwishStatus(null);
    }
    switch (fileExport.key) {
      case Reports.SUS:
      case Reports.SWISH:
        setColumns(claimColumns);
        break;
      case Reports.SusHistory:
        setColumns(susHistoryColumns);
        break;
      case Reports.Settlement:
        setColumns(settlementColumns);
        break;
      case Reports.Fraud:
        setColumns(fraudReportColumns);
        setSortBy("ClaimWithoutTicketNumber");
        break;
      default:
        setColumns(claimColumns);
        break;
    }
  };

  const exportFile = async () => {
    switch (fileExport.key) {
      case Reports.SUS:
        await exportSUSFile();
        break;
      case Reports.Settlement:
        await exportSettlementReport();
        break;
    }
  };

  const backupSUSFile = async () => {
    let data = await fetchClaimReport(0, totalPages, DisplayClaimType.SusReport);
    setSusBackupRows(data.items);
  };

  const exportSettlementReport = async () => {
    var data = await fetchClaimReport(0, totalPages, DisplayClaimType.ExportSettlement);
    setSettlementRows(data.items);
  };

  const createSwishPayout = async () => {
    setStartDateErr(!startDate);
    setEndDateErr(!endDate);
    if (!startDate || !endDate || fileExport.key !== Reports.SWISH || rows.length < 1) return;
    let payload = {};
    if (startDate) {
      payload.fromDate = formatDate(startDate);
    }
    if (endDate) {
      payload.toDate = formatDate(endDate);
    }
    let result = await BusClaimApiService.createSwishPayout(payload);
    if (result?.isSuccess) {
      setPayoutNumber(result.data);
    } else SnackbarUtils.error(t("error"));
  };

  const exportSUSFile = async () => {
    setStartDateErr(!startDate);
    setEndDateErr(!endDate);
    if (!startDate || !endDate || fileExport.key !== Reports.SUS) return;
    let payload = {};
    if (startDate) {
      payload.fromDate = formatDate(startDate);
    }
    if (endDate) {
      payload.toDate = formatDate(endDate);
    }
    let backup = await fetchClaimReport(0, totalPages, DisplayClaimType.SusReport);
    if (backup && backup.items?.length > 0) {
      var result = await BusClaimApiService.exportSUSFile(payload);
      if (result?.isSuccess) {
        SnackbarUtils.success(t("export_ready"));
        var data = await fetchClaimReport(0, 10, DisplayClaimType.SusReport);
        setPage(0);
        setRowsPerPage(10);
        setRows(data.items);
        setTotalPages(data.totalCount);
        setSusBackupRows(backup.items);
      } else SnackbarUtils.error(t("error"));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const payoutsCompleted = () => {
    return payouts && payouts.length > 0 && payouts.every((p) => p.status.toLowerCase() !== "created");
  };

  const payoutErrors = () => {
    return payouts?.filter((p) => p.errorMessage && p.errorCode !== "TA01" && p.status.toLowerCase() === "error");
  };

  const payoutsNotResponding = () => {
    return payouts?.filter((p) => (!p.errorMessage || p.errorCode === "TA01") && p.status.toLowerCase() === "error");
  };

  const shouldHighlightHighReimbursement = (row) => {
    if (fileExport.key !== Reports.SUS && fileExport.key !== Reports.SWISH) return false;
    const reimbursement = Number(row?.ReimbursementSEK);
    return Number.isFinite(reimbursement) && reimbursement >= 5000;
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex" }} justifyContent="space-between">
        <Box sx={{ display: "flex" }}>
          <MyDropdown disableClearable={true} size="small" fullWidth={false} style={{ width: "10rem", margin: "1rem 0rem 1rem 1rem" }} onChange={(e, value) => handleFileExportChange(value)} label={t("report")} value={fileExport} options={options} />
          {fileExport.key !== Reports.SusHistory && <MyDatePicker error={startDateErr} clearable={false} size="small" onAccept={(date) => setStartDate(date?.toString())} value={startDate} label={t("from")} style={{ width: "12rem", margin: "1rem 0 1rem 1rem" }} />}
          {fileExport.key !== Reports.SusHistory && <MyDatePicker error={endDateErr} clearable={false} size="small" onAccept={(date) => setEndDate(date?.toString())} value={endDate} label={t("to")} style={{ width: "12rem", margin: "1rem 0 1rem 1rem" }} />}
          {fileExport.key === Reports.Settlement && <MySelect size="small" style={{ width: "14rem", margin: "1rem 0rem 1rem 1rem" }} label={t("provider")} onChange={setProviders} options={BusProviderOptions} value={providers} />}
          {(fileExport.key === Reports.SUS || fileExport.key === Reports.Settlement) && <MyButton onClick={exportFile} text={t("export")} value="" style={{ width: "7rem", margin: "1rem 1rem 1rem 1rem" }} />}
          <MyButton disabled={payoutNumber !== ""} hidden={fileExport.key !== Reports.SWISH} onClick={async () => await createSwishPayout()} text={t("payout")} value="" style={{ width: "7rem", margin: "1rem 1rem 1rem 1rem" }} />
          <CSVLink
            hidden={true}
            ref={hiddenCSVSettlementLink}
            {...{
              data: settlementRows,
              headers: settlementCSVReportColumns,
              filename: "Claims.csv",
            }}
          ></CSVLink>
          <CSVLink
            hidden={true}
            ref={hiddenCSVSUSLink}
            {...{
              data: susBackupRows,
              headers: claimColumns,
              filename: "Claims.csv",
            }}
          ></CSVLink>
        </Box>
      </Box>
      {fileExport.key === Reports.Settlement && (
        <Box sx={{ display: "flex" }} justifyContent="space-between">
          <Box sx={{ display: "flex" }}>
            <MyCheckbox onChange={setCatchLateApprovals} checked={catchLateApprovals} className="margin left-1 top-0" label={t("catch_late_approvals")} />
          </Box>
        </Box>
      )}
       {swishStatus !== null && swishStatus !== "" && swishStatus !== "none" && (
          <Box>
            <Typography component="div" className="margin left-1 top-0 text-danger font-weight-bold" label={t("swish_issues")}>
            {`${t("swish_issues")}`}
            </Typography>
            <Typography component="div" className="margin left-1 top-1" label={t("swish_issues-link")}>
              {`${t("swish_issues_link")}`}
            </Typography>
          </Box>
        )}
        {swishStatus !== null && swishStatus !== "" && swishStatus === "none" && (
        <Box sx={{ display: "flex" }} justifyContent="space-between">
          <Box sx={{ display: "flex" }}>
            <Typography component="div" className="margin left-1 top-0" label={t("no_swish_issues")}>
            {`${t("no_swish_issues")}`}
            </Typography>
          </Box>
        </Box>
        )}
      <Divider />
      <EnhancedTableToolbar />
      {payoutNumber && (
        <Typography component="div" className="margin left-1">
          {`${t("payouts_created_retrieving_status_from_swish")}`}
        </Typography>
      )}
      {payouts && payouts.length > 0 && (
        <>
          <Typography component="div" className="margin left-1">
            {`${t("payouts_total_amount")} ${payouts?.filter((p) => p.status.toLowerCase() === "paid").reduce((acc, p) => acc + p.amount, 0) ?? 0} SEK`}
          </Typography>
          <Typography component="div" className="margin left-1">
            {`${t("payouts_created")} ${payouts?.length ?? 0}`}
          </Typography>
          <Typography component="div" className="margin left-1">
            {`${t("payouts_completed")} ${payouts?.filter((p) => p.status.toLowerCase() === "paid").length ?? 0}`}
          </Typography>
          {payoutErrors()?.length > 0 && (
            <Typography component="div" className="margin left-1">
              {`${t("payouts_error")} ${payoutErrors()?.length ?? 0} (${payoutErrors()
                ?.map((item) => item.payerPaymentReference)
                ?.join(", ")})`}
            </Typography>
          )}
          {payoutsNotResponding()?.length > 0 && (
            <Typography component="div" className="margin left-1">
              {`${t("payouts_not_responding_try_again_later")} ${payoutsNotResponding()?.length ?? 0} (${payoutsNotResponding()
                ?.map((item) => item.payerPaymentReference)
                ?.join(", ")})`}
            </Typography>
          )}
        </>
      )}
      {payoutNumber && payoutsCompleted() && (
        <Typography component="div" className="margin left-1">
          {`${t("completed")}`}
        </Typography>
      )}
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.sortable ? (
                    <TableSortLabel active={column.id === sortBy} direction={ascending ? "asc" : "desc"} onClick={(e) => handleSort(column.id, !ascending)}>
                      {column.label}
                    </TableSortLabel>
                  ) : (
                    column.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, key) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={key}
                  sx={
                    shouldHighlightHighReimbursement(row)
                      ? {
                          "& td": {
                            backgroundColor: (theme) => theme.palette.warning.light,
                          },
                        }
                      : undefined
                  }
                >
                  {columns.map((column) => {
                    if (column.render) return <TableCell key={column.id}>{column.render(row)}</TableCell>;
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {showMore.some((item) => item == `${key}`) ? value : value?.toString().substring(0, 40)}
                        {value?.toString().length > 40 && (showMore == [] || !showMore.some((item) => item == key)) && (
                          <i className="selector" onClick={() => setShowMore([...showMore, `${key}`])}>
                            {` ...`}
                          </i>
                        )}
                        {value?.toString().length > 40 && showMore != [] && showMore.some((item) => item == key) && (
                          <strong color="primary.main" className="selector" onClick={() => setShowMore([...showMore].filter((item) => item != key))}>
                            {` ${t("show_less")}`}
                          </strong>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination rowsPerPageOptions={[10, 25, 100]} component="div" count={totalPages} labelRowsPerPage={t("rows_per_page")} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
    </React.Fragment>
  );
};
